var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.card_resource.length)?_c('div',{staticClass:"text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.data.card_resource[0].description)}}),_vm._l((_vm.data.card_resource[0].userfile),function(userfile){return _c('amaze-userfile',{key:userfile.id,attrs:{"userfile":userfile}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }